import React, { useEffect, useState } from 'react';
import styles from './TemplatesRegistrationForm.module.scss';
import BtnRegistration from '../../common/BtnRegistration/BtnRegistration';
import TemplateRegistretion from '../TemplateRegistretion/TemplateRegistretion';
import { ReactComponent as TempaletsHouse } from '../../../../../resource/TempaletsHouse.svg';
import { useSelector } from 'react-redux';
import { modeList } from '../../../constants/modeList';

const TemplateNew = () => {
  return (
    <div className={styles.list}>
      <div>
        <TempaletsHouse />
      </div>
      <div>
        <div className={styles.name}>Новый шаблон</div>
        <div className={styles.message}>Текст сообщения</div>
      </div>
    </div>
  );
};

const TemplatesRegistrationList = ({
  templateModem,
  changeTemlateModem,
  houseTemplates,
  changeTemlate,
  selectedTemlates,
  choice,
}) => {
  const currentHouse = useSelector(
    (state) => state.housingStockStore.currentHouse
  );
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    const filterHouseTemplates = () => {
      if (choice) {
        const selectedTemplate = houseTemplates?.find(
          (template) => template.id === currentHouse?.houseTypeAccess.id
        );

        const sortedTemplates = selectedTemplate
          ? [
              selectedTemplate,
              ...houseTemplates?.filter(
                (template) => template.id !== currentHouse?.houseTypeAccess.id
              ),
            ]
          : houseTemplates;

        if (selectedTemplate) {
          changeTemlate(selectedTemplate);
          changeTemlateModem(modeList.SELECTED_MODE);
        }

        return sortedTemplates;
      }

      return houseTemplates;
    };

    const updatedTemplates = filterHouseTemplates() || [];
    setTemplates(updatedTemplates);
  }, [houseTemplates, currentHouse, choice]);

  return (
    <div className={styles.lists}>
      <div className={styles.listItem}>
        {templateModem === modeList.ADD_TEMPLATE_MODE ? <TemplateNew /> : ''}
        {templates.map((template) => {
          return (
            <TemplateRegistretion
              key={template.id}
              template={template}
              classTempale={selectedTemlates?.id === template.id}
              changeTemlate={changeTemlate}
              changeTemlateModem={changeTemlateModem}
              choice={choice}
            />
          );
        })}
      </div>
    </div>
  );
};

const TemplatesRegistrationForm = ({
  templateModem,
  changeTemlateModem,
  houseTemplates,
  changeTemlate,
  selectedTemlates,
  choice,
}) => {
  const createTemplate = () => {
    changeTemlate(null);
    changeTemlateModem(modeList.ADD_TEMPLATE_MODE);
  };

  return (
    <div className={styles.conteiner}>
      <div className={styles.header}>
        <h3 className={styles.title}>Шаблоны</h3>
        {templateModem !== modeList.ADD_TEMPLATE_MODE && (
          <BtnRegistration
            title="Создать новый шаблон"
            text="Создать новый"
            onClick={createTemplate}
          />
        )}
      </div>
      <TemplatesRegistrationList
        choice={choice}
        templateModem={templateModem}
        changeTemlateModem={changeTemlateModem}
        selectedTemlates={selectedTemlates}
        changeTemlate={changeTemlate}
        houseTemplates={houseTemplates}
      />
    </div>
  );
};

export default TemplatesRegistrationForm;
